var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-info-item"},[_c('span',{staticClass:"title",style:(`width: ${_vm.width}px;`)},[_vm._v(_vm._s(_vm.title))]),(_vm.content)?_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }